<div class="order-wrapper">
	<!-- Order Details Section -->
	<div class="order-details">
		<h2 class="section-title">{{ orderConstants.orderDetails }}</h2>
		<div class="order-card">
			<div class="order-row">
				<span class="label">{{ orderConstants.trackingNumber }}</span>
				<span class="value highlight">{{ deliveryItem?.upi }}</span>
			</div>
			<div class="order-row">
				<span class="label">{{ orderConstants.productDescription }}</span>
				<span class="value highlight">{{ deliveryItem?.item_description }}</span>
			</div>
		</div>
	</div>

	<!-- Contact Details Section -->
	<div class="contact-header">
		<h2 class="section-title">{{ orderConstants.contactDetails }}</h2>
		<a class="update-link btn" (click)="openUpdateDialog()">{{ orderConstants.updateButton }}</a>
	</div>

	<div class="contact-card">
		<p class="name">
			<strong>{{ wismoDetails?.first_name }} {{ wismoDetails?.last_name }}</strong>
		</p>
		<ul class="contact-list">
			<li><i class="fa fa-envelope"></i> {{ wismoDetails?.order_hdr_wismo_info?.order_hdr_wismo_info_item[0].email_address }}</li>
			<li>
				<i class="fa fa-map-marker-alt"></i> {{ wismoDetails?.address_line_1 }} {{ wismoDetails?.address_line_2 }}
				{{ wismoDetails?.city }} {{ wismoDetails?.county }} {{ wismoDetails?.post_code }}
			</li>
			<li><i class="fa fa-info-circle"></i> {{ wismoDetails?.contact_phone }}</li>
			<li><i class="fa fa-phone"></i> {{ wismoDetails?.mobile_phone }}</li>
			<li><i class="fa fa-home"></i> {{ wismoDetails?.home_phone }}</li>
			<li><i class="fa fa-briefcase"></i> {{ wismoDetails?.work_phone }}</li>
		</ul>
	</div>
	<div class="confirm-button">
		<button mat-button color="primary" class="btn mt-4" (click)="onConfirmDetails()">{{ orderConstants.btnConfirmDetails }}</button>
	</div>
</div>
